export const isLinkPresentInParentPages = (parentPages?: Array<{ url: string; title?: string }>, url?: string) => {
	if (!parentPages || !url) {
		return false
	}
	return Boolean(parentPages?.find((page) => page.url === url))
}
